module.exports = __webpack_public_path__ + "img/it_it_day-5.8839a165.svg";